import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import i18n from '~/i18n'
import TwoColPaperExplainer from '~/Common-Objects/DomainManagement/Components/TwoColPaperExplainer'
import ThreeColPaper from '~/Common-Objects/DomainManagement/Components/ThreeColPaper'
import AutomationSteps from '~/Common-Objects/Automations/automationSteps'
import moment from 'moment'
export default function VeryifySetup({ domain, setFlowStep, finish = () => { }, getDomain }) {

    const site = useSelector((state) => state.siteMaster)

    const [hasIssues, setHasIssues] = useState(0);
    const [statuses, setStatuses] = useState({});

    const passedTimerRef = useRef(null);

    useEffect(() => {
        checkTimer();

        return () => {
            if (passedTimerRef.current) {
                clearTimeout(passedTimerRef.current);
                passedTimerRef.current = null;
            }
        }
    }, [])

    const checkTimer = async () => {
        if (passedTimerRef.current) {

            clearTimeout(passedTimerRef.current);
            passedTimerRef.current = null;
        }
        checkPassedAll();
        passedTimerRef.current = setTimeout(() => {
            checkTimer();
        }, 10000);
    }

    const checkPassedAll = async () => {
        let tmpDomain = await getDomain();
        tmpDomain = tmpDomain.domain;

        let spfStatus = tmpDomain.spfAdded ? 1 : 0;
        if (spfStatus) {
            if (tmpDomain.authenticated) {
                spfStatus = 2;
            }
            else
            {
                if(tmpDomain.options?.lastAuthenticationCheckDate && moment(tmpDomain.options?.lastAuthenticationCheckDate).isValid()) {
                    if(moment().isBefore(moment(tmpDomain.options?.lastAuthenticationCheckDate).add(1, 'days'))) {
                        spfStatus = 0;
                    }
                }
            }
        }
        let dkimStatus = tmpDomain.dkimAdded ? 1 : 0;
        if (dkimStatus) {
            if (tmpDomain.authenticated) {
                dkimStatus = 2;
            }
            else
            {
                if(tmpDomain.options?.lastAuthenticationCheckDate && moment(tmpDomain.options?.lastAuthenticationCheckDate).isValid()) {
                    if(moment().isBefore(moment(tmpDomain.options?.lastAuthenticationCheckDate).add(1, 'days'))) {
                        dkimStatus = 0;
                    }
                }
            }
        }
        let dmarcStatus = tmpDomain.dmarc ? 2 : 0;

        let trackingStatus = tmpDomain.trackingAdded ? 1 : 0;
        if (trackingStatus) {
            if (tmpDomain.trackingDomain?.authenticated) trackingStatus = 2;
        }

        let cdnStatus = tmpDomain.cdnAdded ? 1 : 0;
        if (cdnStatus) {
            if (tmpDomain.cdnDomain?.authenticated) cdnStatus = 2;
        }

        let tmpStatuses = {
            spf: spfStatus,
            dkim: dkimStatus,
            dmarc: dmarcStatus,
            tracking: trackingStatus,
            cdn: cdnStatus
        }

        setStatuses(tmpStatuses);
        let hasIssues = tmpStatuses.spf == 1 || tmpStatuses.dkim == 1 || tmpStatuses.dmarc == 1;
        if(tmpDomain.options.trackingEnabled && tmpStatuses.tracking == 1) hasIssues = true;
        if(tmpDomain.options.cdnEnabled && tmpStatuses.cdn == 1) hasIssues = true;

        let hasUnadded = tmpStatuses.spf == 0 || tmpStatuses.dkim == 0 || tmpStatuses.dmarc == 0;
        if(tmpDomain.options.trackingEnabled && tmpStatuses.tracking == 0) hasUnadded = true;
        if(tmpDomain.options.cdnEnabled && tmpStatuses.cdn == 0) hasUnadded = true;
       
        if (hasIssues) {
            setHasIssues(1);
        }
        else if (hasUnadded) {
            setHasIssues(2);
        }
        else {
            const hasOptional = !tmpDomain.options.trackingEnabled || !tmpDomain.options.cdnEnabled
            setHasIssues(hasOptional ? 3 : 0);
        }
    }

    const verifiedHtml = <div className="text-green text-heavy" style={{ display: "flex", gap: "4px" }}>
        <Icons icon="tickCircle" color={"#4AB7A9"} style={{ height: 20 }} />
        <div style={{ fontSize: "13px" }}>{i18n.t('company:domains.domainManagement.verified')}</div>
    </div>;

    const notVerifiedHtml = <div className="text-red text-heavy" style={{ display: "flex", gap: "4px" }}>
        <Icons icon="alert" color={"#E75C5A"} style={{ height: 20 }} />
        <div style={{ fontSize: "13px" }}>{i18n.t('company:domains.domainManagement.notVerified')}</div>
    </div>;

    const checkingHtml = <div className="text-heavy" style={{ display: "flex", gap: "4px", color: "#C78E00" }}>
        <Icons icon="loading" color={"#C78E00"} style={{ height: 20 }} />
        <div style={{ fontSize: "13px" }}>{i18n.t('company:domains.domainManagement.waitingDns')}</div>
    </div>;

    return (
        <>
            <h2 className='mar-b15 text-center'>
                {domain?.options?.forwardedInstructions && i18n.t('company:domains.domainManagement.verifyingHeaderNotifiedColleague')}
                {!domain?.options?.forwardedInstructions && i18n.t('company:domains.domainManagement.verifyingHeader')}
            </h2>
            <div className='mar-b40 text-center text-grey-800' style={{ lineHeight: '1.5' }}>
                {domain?.options?.forwardedInstructions && i18n.t('company:domains.domainManagement.verifyingDescNotifiedColleague')}
                {!domain?.options?.forwardedInstructions && i18n.t('company:domains.domainManagement.verifyingDesc')}
            </div>

            <AutomationSteps.Group title={undefined} style={{ width: "100%" }} className="mar-b16">
                <AutomationSteps.Step
                    iconHolderStyle={{ display: "flex", alignItems: "center", justifyItems: "center" }}
                    icon={<Icons icon='envelopeOutlineTick' color='#7C8086' style={{ width: "16px", height: "16px" }} />}
                    onClick={() => { }}
                    clickable={false}
                    hoverable={false}
                    title={<div className="text-heavy">{i18n.t('company:domains.domainManagement.spfDkimStep')}</div>}
                    subTitle={undefined}
                    ctaWidth="auto"
                    ctaIcon={statuses.spf == 2 && statuses.dkim == 2 ? verifiedHtml : statuses.spf == 1 || statuses.dkim == 1 ? notVerifiedHtml : checkingHtml}
                />

                <AutomationSteps.Step
                    iconHolderStyle={{ display: "flex", alignItems: "center", justifyItems: "center" }}
                    icon={<Icons icon='shieldtickOutline' color='#7C8086' style={{ width: "16px", height: "16px" }} />}
                    onClick={() => { }}
                    clickable={false}
                    hoverable={false}
                    title={<div className="text-heavy">{i18n.t('company:domains.domainManagement.dmarcStep')}</div>}
                    subTitle={undefined}
                    ctaWidth="auto"
                    ctaIcon={statuses.dmarc == 2 ? verifiedHtml : statuses.dmarc == 1 ? notVerifiedHtml : checkingHtml}
                />

                {domain.options.trackingEnabled && <AutomationSteps.Step
                    iconHolderStyle={{ display: "flex", alignItems: "center", justifyItems: "center" }}
                    icon={<Icons icon='pointerClick' color='#7C8086' style={{ width: "16px", height: "16px" }} />}
                    onClick={() => { }}
                    clickable={false}
                    hoverable={false}
                    title={<div className="text-heavy">{i18n.t('company:domains.domainManagement.trackingStep')}</div>}
                    subTitle={undefined}
                    ctaWidth="auto"
                    ctaIcon={statuses.tracking == 2 ? verifiedHtml : statuses.tracking == 1 ? notVerifiedHtml : checkingHtml}
                />}

                {domain.options.cdnEnabled && <AutomationSteps.Step
                    iconHolderStyle={{ display: "flex", alignItems: "center", justifyItems: "center" }}
                    icon={<Icons icon='imageOutline' color='#7C8086' style={{ width: "16px", height: "16px" }} />}
                    onClick={() => { }}
                    clickable={false}
                    hoverable={false}
                    title={<div className="text-heavy">{i18n.t('company:domains.domainManagement.cdnStep')}</div>}
                    subTitle={undefined}
                    ctaWidth="auto"
                    ctaIcon={statuses.cdn == 2 ? verifiedHtml : statuses.cdn == 1 ? notVerifiedHtml : checkingHtml}
                />}
            </AutomationSteps.Group>

            {domain?.options?.forwardedInstructions && <div className='mar-b40 text-sml quickFlex' style={{ gap: "4px", alignItems: "center" }}>
                <Icons icon="questionCircle" color={"#37393C"} />
                <div>What do these records mean? <a href="" target="_blank">Learn More</a></div>
            </div>}

            <div style={{ display: "flex", gap: "12px" }}>
                {!domain?.options?.forwardedInstructions && <>
                    {hasIssues == 1  &&
                        <Button onClick={() => { setFlowStep("dnsInstructions") }} className="button-primary" iconRight={<Icons icon="arrowRight" color={"#FFFFFF"} />}>
                            <div>{i18n.t('company:domains.domainManagement.fixIssues')}</div>
                        </Button>
                    }
                    {hasIssues == 3 &&
                        <Button onClick={() => { setFlowStep("dnsInstructions") }} className="button-primary" iconRight={<Icons icon="arrowRight" color={"#FFFFFF"} />}>
                            <div>{i18n.t('company:domains.domainManagement.addOptional')}</div>
                        </Button>
                    }
                    <Button onClick={() => {
                        finish();
                    }}
                        className={hasIssues == 2 ? "button-primary" : ""}>
                        <div>{i18n.t('company:domains.domainManagement.backToSite', { siteName: site.siteName })}</div>
                    </Button>
                    
                    {hasIssues == 2 &&
                        <Button onClick={() => { setFlowStep("dnsInstructions") }} className="" iconRight={<Icons icon="arrowRight" color={"#000000"} />}>
                            <div>{i18n.t('company:domains.domainManagement.viewDnsInstructions')}</div>
                        </Button>
                    }
                </> 
                }
                {domain?.options?.forwardedInstructions && <>
                
                    <Button onClick={() => {
                        finish();
                    }}
                        className={"button-primary"}>
                        <div>{i18n.t('company:domains.domainManagement.backToSite', { siteName: site.siteName })}</div>
                    </Button>

                    {hasIssues == 1  &&
                        <Button onClick={() => { setFlowStep("dnsInstructions") }} className="">
                            <div>{i18n.t('company:domains.domainManagement.fixIssues')}</div>
                        </Button>
                    }
                    {hasIssues == 2 &&
                        <Button onClick={() => { setFlowStep("dnsInstructions") }} className="">
                            <div>{i18n.t('company:domains.domainManagement.viewDnsInstructions')}</div>
                        </Button>
                    }
                    {hasIssues == 3 &&
                        <Button onClick={() => { setFlowStep("dnsInstructions") }} className="">
                            <div>{i18n.t('company:domains.domainManagement.addOptional')}</div>
                        </Button>
                    }

                </>}
            </div>

            {(hasIssues == 1 || hasIssues == 2) && domain?.options?.forwardedInstructions && <div className='mar-t16'>
                Need to send it again? <a onClick={() => {
                    setFlowStep("sendInstructions");
                }}
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                }}>
                   Resend Instructions
                   <Icons icon="arrowRight" color={"#5934BF"} style={{display: "inline-block", marginLeft: "0px", height: "16px"}}/>

                    
                </a>
                </div>}

        </>
    )
}